module.exports = "/content/7d8693c31f27bd177c31176ad0d38fe8.png";